// Viktor — Death Ray: Fires a laser beam through all enemies. Damage ramps up
// from front to back — backline enemies take 70% more damage than frontline.

import { magicDamage } from "../../combat/DamageCalc";
import { effectiveStats } from "../UnitStats";
import type { Ability, AbilityHit } from "./Ability";

const DELAY_PER_SLOT = 120;

export const viktorDeathRay: Ability = {
  id: "viktorDeathRay",
  displayName: "Death Ray",
  description: "Fires a laser through all enemies. Damage ramps up from front (0.7 AP+40) to back (1.2 AP+80).",
  iconId: "ViktorE",

  targetShape({ caster, combat }) {
    const team = caster.team === "player" ? "enemy" : "player";
    return combat.livingUnitsOf(team).map(e => e.pos);
  },

  computeHits({ caster, combat }): AbilityHit[] {
    const team = caster.team === "player" ? "enemy" : "player";
    const enemies = combat.livingUnitsOf(team).sort((a, b) => a.pos.q - b.pos.q);
    if (enemies.length === 0) return [];
    const stats = effectiveStats(caster);
    const maxSlot = Math.max(...enemies.map(e => e.pos.q), 1);

    return enemies.map((e, i) => {
      const t = enemies.length > 1 ? e.pos.q / maxSlot : 0.5; // 0 = front, 1 = back
      const apMult = 0.7 + t * 0.5;  // 0.7 → 1.2
      const base   = 44  + t * 44;   // 44  → 88
      return {
        target: e,
        amount: magicDamage(stats.ap * apMult + base),
        type: "magical" as const,
        suppressPopup: i > 0,
        delayMs: i * DELAY_PER_SLOT,
      };
    });
  },
};
